import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./Navbar.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile, setIsProfileLoading } from "../../../reducer/profileSlice";
import UserProfileDropDown from "../../UserProfileDropDown/UserProfileDropDown";
import FeedNavbarSVG from "../../SVGComponents/FeedNavbarSVG";
import ProjectsNavbarSVG from "../../SVGComponents/ProjectsNavbarSVG";
import NotificationsSVG from "../../SVGComponents/NotificationsSVG";
import NoImageSVG from "../../SVGComponents/NoImageSVG";
import Modal from "../../Modal/Modal";
import PlusIconSVG from "../../SVGComponents/PlusIconSVG";
import NewPostSocialFeed from "../../NewPostSocialFeed/NewPostSocialFeed";
// import QreativesLogo from "components/common/QreativesLogo/QreativesLogo";
// import QreativesLogoSVG from "components/SVGComponents/QreativesLogoSVG";
import BusinessProfileForm from "components/BusinessProfileForm/BusinessProfileForm";
import { removeTokens, serverFiles } from "utils/utils";
import NotificationsPage from "../../../pages/NotificationsPage/NotificationsPage";
import { getAllNotifications } from "reducer/notificationSlice";
import CreativesLogoSVG from "components/SVGComponents/CreativesLogoSVG";
import { getActivePlanOfUser } from "reducer/paymentSlice";
import NewPostSocialFeedForModal from "components/NewPostSocialFeed/NewPostSocialFeedForModal";
import NO_IMAGE from "../../../images/NO_IMAGE.jpg";
import SearchIconSVG from "components/SVGComponents/SearchIconSVG";
import GlobalSearch from "../GlobalSearch/GlobalSearch";

const Navbar = () => {
  const { userProfile, isProfileLoading } = useSelector(
    (state) => state.userProfile
  );
  const { notifications } = useSelector((state) => state.notifications);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notificationModal, setNotificationModal] = useState(false);
  const [newPostModal, setNewPostModal] = useState(false);
  const [businessProfile, setBusinessProfile] = useState(false);
  const [showDropDown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const [page, setPage] = useState(0);
  const page = 0;
  const [showRedDot, setShowRedDot] = useState(false);
  const size = 1;

  // const profileImage = localStorage.getItem("profileImage");

  const { pathname } = useLocation();

  const companyLogo = userProfile?.companyResponseDto?.logo;
  const userProfileImage = userProfile?.profileUrl;

  const hasImage = !!(userProfileImage || companyLogo);

  const imageSrc = serverFiles(companyLogo || userProfileImage);

  const getNotifications = async () => {
    const params = {
      page,
      size,
    };
    try {
      const res = await dispatch(getAllNotifications(params));
      return res?.payload;
    } catch (error) {
      console.log(error);
    }
  };

  const checkNewNotifications = (data) => {
    const hasUnread = data?.some?.(
      (notification) => notification.isRead === false
    );
    setShowRedDot(hasUnread);
    if (data?.length === 0) {
      setShowRedDot(false);
      // console.log("showRedDot", showRedDot);
      return;
    }
    // console.log("setShowRedDot", showRedDot);
  };

  useEffect(() => {
    const checkUserisValid = async () => {
      try {
        const { payload } = await dispatch(getUserProfile());
        // console.log('payload', payload)
        if (
          payload?.userType === "BUSINESS" ||
          (payload?.userType === "CREATOR")
        ) {
          dispatch(setIsProfileLoading(false));
          // setIsLoading(false)
          return;
        } else {
          // toast.error("Please fill up registration form by signing in again");
          removeTokens();
          // window.location.reload();
          navigate("/signin");
        }
      } catch (error) {
        console.log(error);
      }
    };
    // if (!isLoading) {
    checkUserisValid();
    // }
  }, []);


  useEffect(() => {
    const fetchAndCheckNotifications = async () => {
      const data = await getNotifications();
      checkNewNotifications(data || []);
    };

    fetchAndCheckNotifications();

    const interval = setInterval(fetchAndCheckNotifications, 5000);
    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (userProfile?.userType === "BUSINESS") {
      dispatch(getActivePlanOfUser());
    }
  }, [userProfile?.userType]);

  if (isProfileLoading && !userProfile) {
    return <div></div>;
  }

  return (
    <nav className={styles.navbar}>
      <section className={styles.navLeft}>
        {/* <QreativesLogoSVG height={30} width={30} /> */}
        <Link to={"/feed"} className={styles.creativesLogo}>
          <CreativesLogoSVG />
        </Link>

        {pathname !== "/profile-creation" && (
          <div className={styles.navLinks}>
            <Link
              className={`${styles.navLink} ${pathname === "/feed" ? styles.navLinkSelected : ""
                }`}
              to="/feed"
            >
              <span className={styles.navLinkLogo}>
                <FeedNavbarSVG
                  style={{
                    height: "1.6rem",
                    width: "1.6rem",
                  }}
                />
              </span>
              FEED
            </Link>
            <Link
              className={`${styles.navLink} ${pathname === "/projects" ? styles.navLinkSelected : ""
                }`}
              to="/projects"
            >
              <span className={styles.navLinkLogo}>
                <ProjectsNavbarSVG
                  style={{
                    height: "1.6rem",
                    width: "1.6rem",
                  }}
                />
              </span>
              PROJECTS
            </Link>
            <div
              className={`${styles.navLink} ${pathname === "/notifications" ? styles.navLinkSelected : ""
                }`}
              onClick={() => setNotificationModal(true)}
            >
              <span className={styles.navLinkLogo}>
                <NotificationsSVG style={{ height: "1.6rem", width: "1.6rem" }} />
                {showRedDot && <span className={styles.redDot}></span>}
              </span>
              NOTIFICATION
            </div>

            <Modal
              onClose={() => setNotificationModal(false)}
              heading="Notifications"
              modalOpen={notificationModal}
              showCrossIcon={true}
            >
              <NotificationsPage
                setShowRedDot={setShowRedDot}
                onClose={() => setNotificationModal(false)}
              />
            </Modal>

          </div>
        )}
      </section>
      <section className={styles.navRight}>
        <div className={styles.navSearch}>
          {pathname === "/feed" && <GlobalSearch />}

          {pathname === "/feed" && (
            <>
              <button
                onClick={() => setNewPostModal(true)}
                className={styles.navNewPostBtn}
              >
                <PlusIconSVG fill="white" height={16} width={16} /> New Post
              </button>

              <Modal
                background="white"
                modalOpen={newPostModal}
                onClose={() => setNewPostModal(false)}
              >
                <NewPostSocialFeedForModal
                  onClose={() => setNewPostModal(false)}
                />
              </Modal>
            </>
          )}
        </div>

        <div
          className={styles.navUserProfile}
          onClick={() => {
            setShowDropdown((prev) => !prev);
          }}
        >
          {hasImage ? (
            <div className="user-image-relative-div">
              <img
                className={styles.userImage}
                src={imageSrc}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
              />
            </div>
          ) : (
            <NoImageSVG
              onClick={() => {
                setShowDropdown((prev) => !prev);
              }}
            />
          )}
        </div>

        {showDropDown && (
          <UserProfileDropDown
            setBusinessModal={setBusinessProfile}
            setShowDropdown={setShowDropdown}
            userProfile={userProfile}
            showDropDown={showDropDown}
          />
        )}

        {businessProfile && (
          <Modal
            width="40rem"
            background="white"
            modalOpen={businessProfile}
            onClose={() => setBusinessProfile(false)}
          >
            <BusinessProfileForm setBusinessProfile={setBusinessProfile} />
          </Modal>
        )}
      </section>
    </nav>
  );
};

export default Navbar;
